import render from '../components/render'
import stage from '../components/stage'
import gsap from 'gsap'

// import barba from '@barba/core';
// import barbaPrefetch from '@barba/prefetch';
// import barbaCss from '@barba/css';
import bezier from 'bezier-easing'
import 'jquery.scrollto'


import Component from 'gia/Component';
import loadComponents from 'gia/loadComponents';
import eventbus from 'gia/eventbus';
import getComponentFromElement from 'gia/getComponentFromElement';
import removeComponents from 'gia/removeComponents';

import config from 'gia/config';
import '../components/timeout'

import Text from './text'
import Contact from './contact'
import Article from './article'
import Page from './page'


import lazySizes from 'lazysizes';
lazySizes.cfg.lazyClass = 'lazy';
// lazySizes.cfg.loadMode = 1;
// lazySizes.cfg.init = false;

import Highway from './highway';
import CustomRenderer from './custom-renderer';
import CustomTransition from './custom-transition';

class App {

  constructor($) {
    this.create()
  }

  create() {

      // lazySizes.init()
      this.ease = bezier(.48,0,.12,1);
      this.ease2 = bezier(.25,.46,.45,.94);

      config.set('log', false); // disables unnecessary console.log calls

      $('.menu__button').on('click', (e)=>{
          e.preventDefault()
          $('body').toggleClass('has-menu')
      })



      const H = window.H = new Highway.Core({
        renderers: {
          page: CustomRenderer,
          home: CustomRenderer
        },
        transitions: {
          default: CustomTransition
        }
      });



  }


}

module.exports = App
